module.exports = __webpack_public_path__ + "media/images/gallery-c9ac723f29626bbf679ea2b77959c2ca.png";